/**
 * API error handling utilities
 */

/**
 * Handle API error responses consistently
 * @param response - Failed fetch response
 * @returns Never - always throws
 */
export async function handleApiError(response: Response): Promise<never> {
  const error = await response.json().catch(() => null);
  const message = error?.detail || response.statusText;
  throw new Error(`HTTP ${response.status}: ${message}`);
}
